export default "__VITE_ASSET__Cm5B_nWx__"